/* Every "Join Rockkt" link on the site goes to one page: /pages/join. v1.

   Until 8 Oct 2026 the button went to three different places depending on the
   page: /pages/contact (homepage and the feature pages), /pages/request-an-
   invite (most other pages and every footer) and /#cta (Pricing). Glen asked
   for one destination. /pages/join offers both ways in: sign up now via the
   pricing page, or send a message.

   WHERE IT IS FIXED AT SOURCE. rockkt-page-head, rockkt-page-foot,
   rockkt-home-foot-v1, rockkt-chrome-head-v1 and rockkt-chrome-foot-v1 print
   /pages/join directly, so most pages need nothing from this file.

   WHAT THIS IS FOR. The copies the Admin API cannot replace as text, or that
   are rebuilt in the browser:
     templates/index.liquid             header, body button, footer (236KB)
     templates/page.rockkt-pricing      header and footer (128KB)
     templates/page.rockkt-invite       header and footer
     snippets/rockkt-home-shell-v2      header on the feature pages (CRLF file)
     assets/rockkt-footer-sync-v7.js    rebuilds the footer "Rockkt" column with
                                        the old /pages/request-an-invite link

   Matched on the link's own text, exactly "Join Rockkt", so "Request an
   invite" links (the Studio Free invitation, from Pricing and the guides) are
   left alone on purpose. Idempotent. Runs now, again after the footer script
   has rebuilt its columns on load, and on any DOM change for the first ten
   seconds, which covers the header menu that rockkt-nav-features-v3.js
   rebuilds. */
(function () {
  var JOIN = '/pages/join';

  function fix() {
    var links = document.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t !== 'join rockkt') continue;
      if (a.getAttribute('href') !== JOIN) a.setAttribute('href', JOIN);
    }
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; fix(); }, 50);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  window.addEventListener('load', function () { fix(); setTimeout(fix, 1500); });

  if (window.MutationObserver) {
    var mo = new MutationObserver(soon);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }
})();
